import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Col, Row} from "react-bootstrap";
import {resetEntity, resetPage} from '../actions';
import {loadGeneralEnum} from "../actions/enums";
import {showModal} from "../actions/modal";
import {loadDog} from '../actions/dogs';
import {loadIntakes} from '../actions/intakes';
import {loadExams} from '../actions/exams';
import {loadEvents} from '../actions/events';
import {loadExits} from '../actions/exits';
import {loadTreatments} from '../actions/treatments';
import {loadFiles} from '../actions/files';
import {defaultState as entityDefaultState} from '../reducers/entity';
import DogDetail from '../components/dog/DogDetail';
import {breadcrumbs, Grid, resolveApiResult, setPageTitle} from "../utils";
import {defaultState} from "../reducers/paginate";
import DogIntakes from "../components/dog/DogIntakes";
import DogExits from "../components/dog/DogExits";
import DogEvents from "../components/dog/DogEvents";
import DogExams from "../components/dog/DogExams";
import DogTreatments from "../components/dog/DogTreatments";
import {BaseStatus} from "../utils/enums";
import DogPrintZK from "../components/dog/DogPrintZK";

class DogDetailPage extends Component {

	constructor(props) {
		super(props);

		this.state = {
			files: [],
			printType: null
		}

		this.handleFetchEnums = this.handleFetchEnums.bind(this);

		this.handlePrintOpen = this.handlePrintOpen.bind(this);
		this.handlePrintClose = this.handlePrintClose.bind(this);
	}

	componentWillMount() {
		this.handleFetchEnums(['breed', 'user', 'vaccine', 'methodExt', 'methodInt'])
		this.loadDog(this.props.match.params.dogId)
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.match.params.dogId !== this.props.match.params.dogId
			|| (nextProps.match.params.tab === 'detail' && this.props.match.params.tab !== 'detail')) {
			this.loadDog(nextProps.match.params.dogId);
		}
	}

	loadDog(dogId) {
		this.props.loadDog(dogId).then((json) => {
			if (resolveApiResult(json)) {
				this.props.loadFiles({dogId, orderCol: "fileId", statuses: [BaseStatus.ACTIVE]}).then((json) => {
					if (resolveApiResult(json)) {
						this.setState({files: json.response.data, printType: null});
					}
				});
			}
		})
	}

	componentWillUnmount() {
		setPageTitle();
	}

	handleFetchEnums(enums) {
		for (const i in enums) {
			if (enums.hasOwnProperty(i)) {
				this.props.loadGeneralEnum(enums[i], {})
			}
		}
	}

	handlePrintOpen(printType) {
		this.setState({printType})
	}

	handlePrintClose() {
		this.setState({printType: null})
	}

	renderPrint() {
		const {
			entity,
			intakesPage, exitsPage, eventsPage, examsPage, treatmentsPage,
			session, enums
		} = this.props;
		const {printType} = this.state;
		if (!printType) {
			return null;
		}

		const modal = {
			onHide: this.handlePrintClose
		}

		switch (printType) {
			case 'ZK':
				return <DogPrintZK dog={entity.item}
					intakesPage={intakesPage}
					exitsPage={exitsPage}
					eventsPage={eventsPage}
					treatmentsPage={treatmentsPage}
					examsPage={examsPage}
					enums={enums} modal={modal} session={session}/>

			default:
				return null;
		}
	}

	render() {
		const {
			match: {params}, entity,
			intakesPage, exitsPage, eventsPage, examsPage, treatmentsPage,
			session, enums
		} = this.props;
		const {files} = this.state;
		const tab = params.tab || 'detail';
		const dogId = entity && entity.item ? entity.item.dogId : 1 * params.dogId;

		const bc = [
			{url: '/psi', title: 'Psi'},
			{url: '/psi/' + params.dogId, title: entity.item ? entity.item.name : '...', literal: true}
		];
		if (tab !== 'detail') {
			bc.push({url: '/psi/' + params.dogId + '/' + tab, title: tab});
		}

		let body;
		if (!entity.item || !entity.item.dogId) {
			if (entity.isFetchingItem) {
				body = Grid.renderIsFetchingData();
			} else {
				body = <em>Nenalezeno</em>
			}
		} else {
			body = <Row>
				<Col lg={6}>
					<Row>
						<Col lg={12}>
							<DogDetail {...entity}
								files={files}
								intakes={intakesPage.items}
								enums={enums} session={session}
								onPrintOpen={this.handlePrintOpen}/>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<DogExams {...examsPage}
								dogId={dogId}
								files={files}
								onFetchData={(dogId, full = false) => {
									if (full) {
										this.loadDog(dogId);
									}
									return this.props.loadExams({dogId, orderCol: "examDate", orderDir: "desc", statuses: [BaseStatus.ACTIVE]});
								}}
								onShowModal={this.props.showModal}
								enums={enums} session={session}/>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<DogIntakes {...intakesPage}
								dogId={dogId}
								dog={entity.item}
								files={files}
								onFetchData={(dogId, full = false) => {
									if (full) {
										this.loadDog(dogId);
										this.props.loadExams({dogId, orderCol: "examDate", orderDir: "desc", statuses: [BaseStatus.ACTIVE]});
									}
									return this.props.loadIntakes({dogId, orderCol: "intakeAt", orderDir: "desc", statuses: [BaseStatus.ACTIVE]});
								}}
								onShowModal={this.props.showModal}
								enums={enums} session={session}/>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<DogExits {...exitsPage}
								dogId={dogId}
								files={files}
								onFetchData={(dogId, full = false) => {
									if (full) {
										this.loadDog(dogId);
									}
									return this.props.loadExits({dogId, orderCol: "exitAt", orderDir: "desc", statuses: [BaseStatus.ACTIVE]});
								}}
								onShowModal={this.props.showModal}
								enums={enums} session={session}/>
						</Col>
					</Row>
				</Col>
				<Col lg={6}>
					<Row>
						<Col lg={12}>
							<DogTreatments {...treatmentsPage}
								dogId={dogId}
								onFetchData={(dogId) => this.props.loadTreatments({dogId, orderCol: "treatDate", orderDir: "desc", statuses: [BaseStatus.ACTIVE]})}
								onShowModal={this.props.showModal}
								enums={enums} session={session}/>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<DogEvents {...eventsPage}
								dogId={dogId}
								files={files}
								onFetchData={(dogId, full = false) => {
									if (full) {
										this.loadDog(dogId);
									}
									return this.props.loadEvents({dogId, orderCol: "eventDate", orderDir: "desc", statuses: [BaseStatus.ACTIVE]});
								}}
								onShowModal={this.props.showModal}
								enums={enums} session={session}/>
						</Col>
					</Row>
				</Col>
			</Row>;
		}

		return (
			<div className={'detail'}>
				<Row>
					<Col xs={12}>
						{breadcrumbs(bc)}
					</Col>
				</Row>
				{body}
				{this.renderPrint()}
			</div>
		)
	}
}

DogDetailPage.propTypes = {
	entity: PropTypes.object.isRequired,
	loadDog: PropTypes.func.isRequired,
	loadIntakes: PropTypes.func.isRequired,
	loadExams: PropTypes.func.isRequired,
	loadEvents: PropTypes.func.isRequired,
	loadExits: PropTypes.func.isRequired,
	loadTreatments: PropTypes.func.isRequired,
	loadFiles: PropTypes.func.isRequired,
	loadGeneralEnum: PropTypes.func.isRequired,
	resetEntity: PropTypes.func.isRequired,
	resetPage: PropTypes.func.isRequired,
	showModal: PropTypes.func.isRequired,
	enums: PropTypes.object,
	session: PropTypes.object.isRequired,
};


const mapStateToProps = (state, ownProps) => {
	const {
		entities: {dogs},
		pagination: {intakes, exams, events, exits, treatments},
		enums,
		session
	} = state;

	const entity = dogs[ownProps.match.params.dogId] || entityDefaultState;
	const intakesPage = intakes[0] || defaultState;
	const examsPage = exams[0] || defaultState;
	const eventsPage = events[0] || defaultState;
	const exitsPage = exits[0] || defaultState;
	const treatmentsPage = treatments[0] || defaultState;

	return {
		entity,
		intakesPage,
		examsPage,
		eventsPage,
		exitsPage,
		treatmentsPage,
		enums,
		session
	}
};

export default connect(mapStateToProps, {
	loadDog,
	loadIntakes,
	loadExams,
	loadEvents,
	loadExits,
	loadTreatments,
	loadFiles,
	loadGeneralEnum,
	resetEntity,
	resetPage,
	showModal
})(DogDetailPage)



// WEBPACK FOOTER //
// ./src/containers/DogDetailPage.js